import { Button } from "@prisma/ui";
import { useTranslation } from "react-i18next";

import { PrismaWordmark } from "../../components/brand/PrismaWordmark";
import { loginUrl } from "../../lib/api";

function Frame({ title, body, reason }: { title: string; body: string; reason?: string | null }) {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-full items-center justify-center bg-app p-8">
      <div className="w-full max-w-lg rounded-[var(--radius-panel)] border border-line bg-surface p-10 shadow-[var(--shadow-card)]">
        <PrismaWordmark className="h-7 w-auto text-ink" role="img" aria-label={t("common.app_name")} />
        <h1 className="mt-8 text-[26px] font-semibold text-ink">{title}</h1>
        <p className="mt-3 text-[15px] leading-relaxed text-ink-2">{body}</p>
        {reason && <p className="mt-3 text-[14px] text-ink-3">{reason}</p>}
        <Button variant="primary" className="mt-8" onClick={() => window.location.assign(loginUrl("/"))}>
          {t("auth.sign_in")}
        </Button>
      </div>
    </main>
  );
}

export function AccessNotProvisioned() {
  const { t } = useTranslation();
  const reason = new URLSearchParams(window.location.search).get("reason");
  const known = ["entitlement", "no_mapped_role", "user_deactivated"];
  return (
    <Frame
      title={t("auth.access_title")}
      body={t("auth.access_body")}
      reason={reason && known.includes(reason) ? t(`auth.access_reason_${reason}`) : null}
    />
  );
}

export function SignedOut() {
  const { t } = useTranslation();
  return <Frame title={t("auth.signed_out_title")} body={t("auth.signed_out_body")} />;
}
